export default __webpack_public_path__ + "static/media/IMG_5543.b3ecd572.jpg";